import SpecialSavedItemFolderIds from "../constants/specialSavedItemFolderIds";
import SavedItemsExpiration from "../constants/savedItemsExpiration";

/**
 * Contains utilities for saved items
 * @class SavedItems
 */

/**
 * Determines if a folderId is a special reserved folderId.
 */
export const isSpecialSavedItemFolder = (folderId) =>
  Object.keys(SpecialSavedItemFolderIds).some(
    (s) => SpecialSavedItemFolderIds[s] === folderId
  );

/**
 * Returns a folder object for the "special" virtual expiration folders.
 */
export const getSpecialFolder = (folderId, userId) => {
  const folder = {
    id: null,
    owner: null,
    expirationHours: null,
  };
  switch (folderId) {
    case SpecialSavedItemFolderIds.GlobalNeverExpiring:
      break;
    case SpecialSavedItemFolderIds.GlobalWeek:
      folder.expirationHours = SavedItemsExpiration.WEEK;
      break;
    case SpecialSavedItemFolderIds.GlobalDay:
      folder.expirationHours = SavedItemsExpiration.DAY;
      break;
    case SpecialSavedItemFolderIds.UserDay:
      folder.expirationHours = SavedItemsExpiration.DAY;
      folder.owner = userId;
      break;
    case SpecialSavedItemFolderIds.UserWeek:
      folder.expirationHours = SavedItemsExpiration.WEEK;
      folder.owner = userId;
      break;
    case SpecialSavedItemFolderIds.UserNeverExpiring:
      folder.owner = userId;
      break;
    default:
      break;
  }

  return folder;
};



// WEBPACK FOOTER //
// ./app/util/savedItemsUtils.js